import { useEffect, useState } from "react";
import { PlantationDetailsPartThreeTableDataAPI } from "../../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../Helper/Context/context";
import { plantationTechniquesPostAPI } from "../../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFourthSlice";
import OtherInsertSection from "../../OtherInsertSection";


const PlantationTechniquesAddPopup = (props) => {

    const { handleAddplantationTechniques, Title, YearValue, MonthValue, T_BeneficiaryPlantationDetailsID, M_BeneficiaryDetailsID,DataIsPost,setDataIsPost } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [RawData, setRawData] = useState([])
    const [PlantationTechniquesData, setPlantationTechniquesData] = useState([])
    const [IsOthersData, setIsOthersData] = useState(false)
    // const [DataIsPost, setDataIsPost] = useState(false)

    const handleUpdateDataIsPost = () => {
        setDataIsPost(!DataIsPost)
        handleAddplantationTechniques()
    }

    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthID: MonthValue,
            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationTechniques",
            token: token,
            setPlantationTechniquesData: setPlantationTechniquesData,
            handleSetData: handleSetData
        }
        dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

    }, [IsOthersData])

    const { isFirstPartLoading } = useSelector(state => state.PlantationDetailsPartThreeTableData)


    var allCheckData = ""

    const handleSetData = (Data) => {
        let roleData = Data?.map((item) => ({ ...item, isChecked: item.isCheck == 1 ? true : false, }))

        setRawData(roleData)
        roleData && roleData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.techniques_M_IndicatorID + ","
            }
        })
        setPlantationTechniquesData(allCheckData)
        // console.log('allCheckData', allCheckData)
    }


    const handleCheckValueChange = (check, index) => {
        if (RawData) {
            let tempGridData = [...RawData]
            tempGridData[index].isChecked = !(tempGridData[index].isChecked)
            setRawData(tempGridData)
        }

        let allCheckData = ""
        RawData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.techniques_M_IndicatorID + ","
            }

            setPlantationTechniquesData(allCheckData)
        })

    }

    const handleSubmit = () => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            RawData: PlantationTechniquesData,
            M_TableUserMasterID: UserID,
            token: token,
            handleDataIsPost :handleUpdateDataIsPost

        }
        // console.log("RawData",PlantationTechniquesData)
        dispatch(plantationTechniquesPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.plantationTechniquesPostData)


    return (<>
        <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
            <div className="modal-dialog modal-xl" role="document"  >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ml-lg-5" id="exampleModalLongTitle">{Title}</h5>
                        <button onClick={handleAddplantationTechniques} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body mx-4">
                        <div className="row">
                            <div className="col-12 py-3">
                                <span className="fw-bold">
                                    Select:
                                </span>
                            </div>
                            {
                                RawData && RawData.length > 0 && RawData.map((i, j) =>
                                    <div className="col-12 col-lg-3 pt-3 ">
                                        <form >
                                            <input type="checkbox"
                                                className="px-3"
                                                id={i.techniques_M_IndicatorID}
                                                name={i.techniques_M_IndicatorID}
                                                checked={i.isChecked}
                                                value={i.techniques_M_IndicatorID}
                                                onChange={() => handleCheckValueChange(1, j)} />

                                            <span for="Weather" className="ps-2">{i.techniques_M_Indicator}</span>
                                        </form>
                                    </div>
                                )}
                            {
                                PlantationTechniquesData?.includes(6) &&
                                <OtherInsertSection
                                    Flag='PlantationTechniques'
                                    IsOthersData={IsOthersData}
                                    setIsOthersData={setIsOthersData}

                                />
                            }


                            <div className="col-12  d-flex justify-content-center pt-5">
                                <div className="form-group w-80 d-flex justify-content-between">

                                    <button
                                        type='button'
                                        onClick={handleSubmit}
                                        className="btn btn-outline-dark border-2 mx-2" data-ktwizard-type="action-next">
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleAddplantationTechniques}
                                        className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default PlantationTechniquesAddPopup;